import { Canvas, useFrame } from "@react-three/fiber";
import { Points, PointMaterial } from "@react-three/drei";
import { useRef } from "react";
import * as THREE from "three";

function Particles() {
  const ref = useRef();

  const count = 3000;
  const positions = new Float32Array(count * 3);

  for (let i = 0; i < count; i++) {
    positions[i * 3] = (Math.random() - 0.5) * 10;
    positions[i * 3 + 1] = (Math.random() - 0.5) * 10;
    positions[i * 3 + 2] = (Math.random() - 0.5) * 10;
  }

  useFrame((state) => {
    const { mouse } = state;

    if (!ref.current) return;

    ref.current.rotation.y += 0.0015;

    ref.current.rotation.x = THREE.MathUtils.lerp(ref.current.rotation.x, mouse.y * 0.4, 0.05);
    ref.current.rotation.y = THREE.MathUtils.lerp(ref.current.rotation.y, mouse.x * 0.4, 0.05);
  });

  return (
    <Points ref={ref} positions={positions} stride={3}>
      <PointMaterial
        color="#60a5fa"
        size={0.03}
        sizeAttenuation
        depthWrite={false}
        transparent
        opacity={0.9}
      />
    </Points>
  );
}

export default function RealityDistortionField() {
  return (
    <div className="fixed inset-0 z-0 pointer-events-none">
      <Canvas camera={{ position: [0, 0, 5] }} gl={{ alpha: true }} dpr={[1, 2]}>
        <Particles />
      </Canvas>
    </div>
  );
}
